import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalHeader, Label, Form, FormGroup, Input} from 'reactstrap'
import DropzoneComponent from 'react-dropzone-component'
import PropTypes from 'prop-types'
import {graphql} from 'react-apollo'
import moment from 'moment'
import UploadFiles from '../../utils/uploadFiles'
import {createCertificateConfirmationMutation} from './mutations'
import { acceptedFiles, acceptedFilesIcons } from '../../utils/uploadFiles'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'

class CertificateConfirmationModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      validationErrors: null,
      files: [],
      next_confirmation_date: moment().add(6, 'M').format('YYYY-MM-DD')
    }

    this.djsConfig = {
      addRemoveLinks: true,
      autoProcessQueue: false,
      acceptedFiles: acceptedFiles,
    }
    this.componentConfig = {
      iconFiletypes: acceptedFilesIcons,
      showFiletypeIcon: true,
      postUrl: 'no-url',
    }
    this.dropzone = null

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
  }

  static propTypes = {
    mutate: PropTypes.func.isRequired,
    isOpened: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    afterSubmit: PropTypes.func.isRequired,
    certificate_id: PropTypes.number.isRequired
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/certificate_confirmation_form') // GA TRACKER
  }

  handleSubmit(event) {
    event.preventDefault()

    this.props.mutate({
      variables: {
        certificate_id: this.props.certificate_id,
        confirmed_at: this.state.next_confirmation_date,
      }
    }).then(({data: {createCertificateConfirmations}}) => {
      if (createCertificateConfirmations.errors) {
        // withGaEvent({category: 'Confirm certificate', action: 'error save'}) // GA EVENT
        this.setState({validation_errors: createCertificateConfirmations.errors})
      } else {
        // withGaEvent({category: 'Confirm certificate', action: 'save'}) // GA EVENT
        // ADD FILE
        if (this.state.files.length > 0) {
          UploadFiles(this.props.certificate_id, 'WlWelders::Qualification', this.state.files).then(() => {
            this.props.afterSubmit()
          }
          )
        } else {
          this.props.afterSubmit()
        }
      }
    })
  }

  handleDateChange(e) {
    let new_date = moment(e.target.value).add(1, 'y').format('YYYY-MM-DD')
    this.setState({next_confirmation_date: new_date})
  }

  handleFileAdded(file) {
    this.setState({files: [...this.state.files, file]})
  }

  handleFileRemoved(file) {
    let newFilesList = this.state.files.filter(function (item) {
      return (item !== file)
    })

    this.setState({files: newFilesList})
  }

  render() {
    const config = this.componentConfig
    const djsConfig = this.djsConfig
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      addedfile: this.handleFileAdded.bind(this),
      removedfile: this.handleFileRemoved.bind(this)
    }

    return (
      <div>
        <Modal isOpen={this.props.isOpened}>
          <ModalHeader>Add confirmation of the certificate validity</ModalHeader>
          <ModalBody>
            <Form id="certificate-confirmation-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
              <FormGroup>
                <Label>Date</Label>
                <Input
                  id="date-certificate-confirmation-form"
                  name="confirmed_at"
                  type="date"
                  defaultValue={new Date().toISOString().substring(0, 10)}
                  onChange={this.handleDateChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label>Next confirmation date</Label>
                <Input
                  id="next-confirmation-date-certificate-confirmation-form"
                  name="next_confirmation_date"
                  type="date"
                  value={this.state.next_confirmation_date}
                  disabled={true}
                  required
                />
              </FormGroup>
              <br/>
              <DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig}/>
              <br/>
              {this.state.validation_errors &&
              <h4 className="errors-heading">{this.state.validation_errors.join(', ')}</h4>
              }
              <FormGroup>
                <Button id="cancel-insp-log-form-btn" className="float-right" color="danger"
                  onClick={this.props.onCancel}>Cancel</Button>
                <Button id="save-insp-log-form-btn" className="float-right" color="primary" type="submit">Save</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

const CertificateModalWithMutations = graphql(createCertificateConfirmationMutation)(CertificateConfirmationModal)

export default CertificateModalWithMutations



// WEBPACK FOOTER //
// ./src/components/Welders/CertificateConfirmationModal.js